module.exports = __webpack_public_path__ + "img/PL00279.6a3f74cc.png";